export function textFloaty(node, text) {

    function handleMousedown(event) {
        if (text) {
            new FloatNode(node, text);
        }
    }

    function FloatNode(parentNode, txt) {

        let template = `
        <div style="position: absolute; left: 30px; background: #000000; border-radius: 8px;">
        <span style="text-align: center;color: #FFFFFF;flex: none;order: 0;align-self: center;margin: 10px 0px;">${txt}</span>
        </div>
        `;
        let container = document.createElement('DIV');
        container.innerHTML = template;
        container.style.transition = 'all 1s';
        container.style.transform = 'translateY(-20px)';
        container.style.opacity = 1;
        parentNode.appendChild(container);
        setTimeout(() => parentNode.removeChild(container), 2000);
        requestAnimationFrame(() => {
            container.style.transform = 'translateY(-100px)';
            container.style.opacity = 0;
        });

    }

    node.addEventListener('mousedown', handleMousedown);

    return {
        destroy() {
            node.removeEventListener('mousedown', handleMousedown);
        }
    };
}